import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';

const DeleteTenantDialog = ({ open, onClose, onConfirm, tenantName }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Tenant</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the tenant <strong>{tenantName}</strong>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="contained">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTenantDialog;
